module.exports = __webpack_public_path__ + "ncalc_icon.svg";